import Image from 'next/image';
import styled from 'styled-components';
import type { HowItWorksProps } from '../';

const DesktopPizzaImage = styled(Image)`
  margin-top: 60px;
  pointer-events: none;
`;

type PizzaDesktopProps = Pick<HowItWorksProps, 'pizzaDesktop'>;

export const PizzaDesktop: React.FC<PizzaDesktopProps> = ({ pizzaDesktop }) => {
  return <DesktopPizzaImage alt="pizza image" loading="lazy" src={pizzaDesktop} width={959} height={428} />;
};
